import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ImageToBeDeleted } from 'src/app/models/internal/image-tobe-deleted';
@Component({
  selector: 'app-imagecontainer',
  templateUrl: './imagecontainer.component.html',
  styleUrls: ['./imagecontainer.component.scss']
})
export class ImagecontainerComponent implements OnInit {
  @Input() fileName: string;
  @Input() url: string;
  @Input() id: number;
  @Input() type: number;
  @Input() showHeader: boolean;
  @Input() showDelete: boolean;
  @Output() private imageDeleteClicked: EventEmitter<ImageToBeDeleted> = new EventEmitter<ImageToBeDeleted>();

  constructor() { 
  }

  ngOnInit() {
  }
  zoomImage()
  {
    var modal = document.getElementById('myModal');
    var img = document.getElementById('myImg');
    const modalImg = document.getElementById("img01") as HTMLImageElement;
    var captionText = document.getElementById("caption");
    var thisImage  = document.getElementById(String(this.id)) as HTMLImageElement;
    modal.style.display = "block";
    modalImg.src = thisImage.src;
  }

  deleteImage()
  {
    const imageToBeDeleted: ImageToBeDeleted = {
      Id: this.id,
      Type: this.type,
      FileName: this.fileName,
      Url: this.url
    }
    this.imageDeleteClicked.emit(imageToBeDeleted);
  }

  close()
  {
    var modal = document.getElementById('myModal');
    modal.style.display = "none";
  }

}
